// assets/atc-loader.js
(function () {
  const LOADER_TIMEOUT_MS = 8000;

  // Capture submit on product add forms (works for <product-form> wrappers too)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

    const btn =
      form.querySelector('add-to-cart-component button[name="add"]') ||
      form.querySelector('button[name="add"]');

    if (!btn || btn.disabled) return;

    // Start loading
    const originalAria = btn.getAttribute('aria-label') || '';
    const originalDisabled = btn.disabled;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-label', 'Adding to cart');

    let cleared = false;
    const clear = () => {
      if (cleared) return;
      cleared = true;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (originalAria) btn.setAttribute('aria-label', originalAria); else btn.removeAttribute('aria-label');
      btn.disabled = originalDisabled;
      cleanup();
    };

    // Listen for common theme events or drawer visibility changes
    const onCartUpdated = () => clear();
    const onDrawerMutation = (mutations, obs) => {
      const drawer = getDrawer();
      if (!drawer) return;
      const open = drawer.hasAttribute('open') || /open|active|is-open/.test(drawer.className);
      if (open) { obs.disconnect(); clear(); }
    };

    // Observe the cart drawer opening (works across many themes)
    const getDrawer = () => (
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-drawer, .drawer--right, .mini-cart')
    );

    document.addEventListener('cart:updated', onCartUpdated, { once: true });
    document.addEventListener('cart:drawer:opened', onCartUpdated, { once: true }); // if Horizon emits this

    const drawer = getDrawer();
    let observer;
    if (drawer) {
      observer = new MutationObserver(onDrawerMutation);
      observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }

    // Hard fallback so we never trap the button
    const t = setTimeout(clear, LOADER_TIMEOUT_MS);

    function cleanup() {
      document.removeEventListener('cart:updated', onCartUpdated, { once: true });
      document.removeEventListener('cart:drawer:opened', onCartUpdated, { once: true });
      if (observer) observer.disconnect();
      clearTimeout(t);
    }
  }, true);
})();
